import { FlexRow } from '@/components/common/Flex';
import { FlexProps } from '@chakra-ui/react';
import { ShareStatus } from '@common/graphql/generated';
import React from 'react';
import ShareStatusToggle from '../common/ShareStatusToggle';

interface ShareSettingsSectionProps
    extends Omit<FlexProps, 'onChange' | 'title'> {
    el: React.ReactNode;
    shareStatus: ShareStatus;
    onChange: (shareStatus: ShareStatus) => void;
    isDisabled: boolean;
}

export default function ShareSettingsSection({
    el,
    onChange,
    shareStatus,
    isDisabled,
    ...props
}: ShareSettingsSectionProps) {
    return (
        <FlexRow
            py={4}
            borderTop="1px solid"
            borderColor="gray.200"
            justify="space-between"
            alignItems="center"
            _last={{ borderBottom: '1px solid', borderColor: 'gray.200' }}
            gap={4}
            {...props}
        >
            {el}
            <ShareStatusToggle
                shareStatus={shareStatus}
                onChangeShareStatus={onChange}
                isDisabled={isDisabled}
            />
        </FlexRow>
    );
}
